import React, { Component } from 'react';

class ContainerDivided extends Component {
    render() {
        const mainContent = this.props.children;
        const sideContent = this.props.sideContent;
        const headerContent = this.props.headerContent;
        const sideAlign = this.props.sideAlign;

        return (
            <div className="col-lg-12 bottom20">
                {/*PAGE HEADER*/}
                {
                    headerContent ? (
                        <div className="page-header">
                            {headerContent}
                        </div>
                    ) : null
                }
                {/*MAIN*/}
                <div className="row m-a w-80p">
                        {/*PAGE RIGHT CONTENT*/}
                        {
                            sideContent ? (
                                <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 ${sideAlign === 'right' ? 'pull-right' : 'pull-left'}`}>
                                    {sideContent}
                                </div>)
                                : null
                        }

                        {/*PAGE MAIN CONTENT*/}
                        <div className={sideContent ? "col-xs-12 col-sm-12 col-md-12 col-lg-9 col-lg-9" : "col-lg-12"}>
                            {mainContent}
                        </div>
                </div>
            </div>
        );
    }
}

export default ContainerDivided;